import survey from "@/services/survey";
import notification from "@/services/notification";

const state = {
  errors: null,
  isLoading: false,
  surveyDetails: null,
  surveyDesign: null
};

const getters = {
  errors: (state) => state.errors,
  isLoading: (state) => state.isLoading,
  surveyDetails: (state) => state.surveyDetails,
  surveyDesign: (state) => state.surveyDesign
};

const mutations = {
  setErrors(state, payload) {
    state.errors = payload;
  },
  setIsLoading(state, payload) {
    state.isLoading = payload;
  },
  setSurveyDetails(state, payload) {
    state.surveyDetails = payload;
  },
  setSurveyDesign(state, payload) {
    state.surveyDesign = payload;
  }
};

const actions = {
  getSurveyDetails: async ({ commit }, payload) => {
    commit("setIsLoading", true);
    try {
      const data = await survey.getSurveyDetails(payload);
      commit("setSurveyDetails", data);
    } catch (errors) {
      commit("setErrors", errors.errors);
    } finally {
      commit("setIsLoading", false);
    }
  },
  getSurveyDesign: async ({ commit }, payload) => {
    commit("setIsLoading", true);
    try {
      const data = await survey.getSurveyDesign(payload);
      commit("setSurveyDesign", data);
    } catch (errors) {
      commit("setErrors", errors.errors);
    } finally {
      commit("setIsLoading", false);
    }
  },
  saveSurveyAnswers: async ({ commit }, payload) => {
    commit("setIsLoading", true);
    
    try {
      await survey.saveSurveyAnswers(payload);

    } catch (errors) {
      if (errors.errors.message == 'Answer Survey limit reached.' || errors.errors.message == 'You have already reached the maximum times you can participate in the survey.') {
        notification.warning("You have already reached the maximum times you can participate in the survey.");
      } else if (errors.errors.message == 'You are sending too many requests. Please try again after a while.') {
        notification.warning("You are sending too many requests. Please try again after a while.");
      } else {
        notification.warning("Oops, cannot save survey answers.");
      }
      commit("setErrors", errors.errors);
    } finally {
      commit("setIsLoading", false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
